<template>
  <MessengerForm :typeEndPoint="'messengerForm'" :dataParams="{}"/>
</template>
<script>
import MessengerForm from '@/components/modules/schoolroutes/messenger/form'
export default {
  name: 'MessengerFormCreate',
  components: {
    MessengerForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/schoolroutes/messenger/create.vue